/**
 * Formata uma data para o padrão brasileiro (dd/mm/aaaa)
 * @param date - Data no formato ISO (yyyy-mm-dd) ou Date object
 * @returns Data formatada no padrão brasileiro
 */
export function formatDateBR(date: string | Date): string {
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    
    // Verificar se a data é válida
    if (isNaN(dateObj.getTime())) {
      return date.toString(); // Retorna o valor original se não conseguir converter
    }
    
    const day = dateObj.getDate().toString().padStart(2, '0');
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const year = dateObj.getFullYear();
    
    return `${day}/${month}/${year}`;
  } catch (error) {
    console.warn('Erro ao formatar data:', error);
    return date.toString();
  }
}

/**
 * Formata uma data e hora para o padrão brasileiro (dd/mm/aaaa às hh:mm)
 * @param date - Data no formato ISO ou Date object
 * @returns Data e hora formatada no padrão brasileiro
 */
export function formatDateTimeBR(date: string | Date): string {
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    
    // Verificar se a data é válida
    if (isNaN(dateObj.getTime())) {
      return date.toString();
    }
    
    const day = dateObj.getDate().toString().padStart(2, '0');
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const year = dateObj.getFullYear();
    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');
    
    return `${day}/${month}/${year} às ${hours}:${minutes}`;
  } catch (error) {
    console.warn('Erro ao formatar data e hora:', error);
    return date.toString();
  }
}

/**
 * Formata apenas a hora no padrão brasileiro (hh:mm)
 * @param date - Data no formato ISO ou Date object
 * @returns Hora formatada
 */
export function formatTimeBR(date: string | Date): string {
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    
    if (isNaN(dateObj.getTime())) {
      return date.toString();
    }
    
    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');
    
    return `${hours}:${minutes}`;
  } catch (error) {
    console.warn('Erro ao formatar hora:', error);
    return date.toString();
  }
}
